import { Action, UserAction, UserState } from '@contexts/Shared/Authentication';
import { setLocalStorageItem } from '@contexts/Shared/utils';
import { removeUserSession } from '../session';

export const userReducer = (state: UserState, action: Action) => {
  switch (action.type) {
    case UserAction.USER_FETCHING_DATA_UPDATE:
    case UserAction.USER_FETCH_ERROR_DATA_UPDATE:
    case UserAction.USER_FETCH_DATA_UPDATE:
      const newState = Object.assign({}, state, action.payload);
      setLocalStorageItem('user-data', JSON.stringify(newState));
      return newState;
    case UserAction.USER_SIGN_OUT: {
      removeUserSession();
      return Object.assign({}, state, action.payload);
    }
    default:
      return state;
  }
};
